import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MarketSizeVisualization } from "@/components/market/MarketSizeVisualization";
import { MarketGrowthChart } from "@/components/market/MarketGrowthChart";
import { MarketAnalysis } from "@/components/market/MarketAnalysis";
import { LogoMarquee } from "@/components/market/LogoMarquee";

const Market = () => {
  const marketGrowthData = [
    { year: 2023, value: 7.16 },
    { year: 2024, value: 7.94 },
    { year: 2025, value: 8.8 },
    { year: 2026, value: 9.75 },
    { year: 2027, value: 10.81 },
    { year: 2028, value: 11.98 },
    { year: 2029, value: 13.28 },
    { year: 2030, value: 14.72 },
  ];

  return (
    <div className="max-w-6xl mx-auto space-y-8">
      {/* Market Size Visualization Card */}
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-xl text-primary">
            Market Size
          </CardTitle>
        </CardHeader>
        <CardContent>
          <MarketSizeVisualization />
        </CardContent>
      </Card>

      {/* Market Growth Chart Card */}
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-xl text-primary">
            Projected Market Growth
          </CardTitle>
        </CardHeader>
        <CardContent className="h-[400px]">
          <MarketGrowthChart data={marketGrowthData} />
        </CardContent>
      </Card>

      {/* Partners & Stakeholders Card */}
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-xl text-primary">
            Saudi Arabia Market Catalysts
          </CardTitle>
        </CardHeader>
        <CardContent>
          <LogoMarquee />
        </CardContent>
      </Card>

      {/* Market Analysis Card */}
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-xl text-primary">
            Market Analysis
          </CardTitle>
        </CardHeader>
        <CardContent>
          <MarketAnalysis />
        </CardContent>
      </Card>
    </div>
  );
};

export default Market;